import IconHands from '../../../assets/icons/IconHands.svg';
import IconBody from '../../../assets/icons/IconBody.svg';
import IconShower from '../../../assets/icons/IconShower.svg';

function variants() {
  return ( 
    <div className='variants'>
      <div className="variants__item">
        <img className="variants__item-icon" src={IconShower} alt="Иконка щётки" />
        <h3 className="variants__item-title">Ручной <br/> подводный душ</h3>
        <ul className="variants__item-list list">
          <li className="list__item">Расслабление мышц</li>
          <li className="list__item">Улучшение кровообращения</li>
          <li className="list__item">Снятие стресса</li>
          <li className="list__item">Стимуляция иммунитета</li>
          <li className="list__item">Тонизирование кожи</li>
          <li className="list__item">Облегчение боли</li>
        </ul>
      </div>
      <div className="variants__item-center">
        <img className="variants__item-icon-center" src={IconHands} alt="Иконка рук" />
        <h3 className="variants__item-center-title">Вакуумный подводный массаж</h3>
        <ul className="variants__item-list list list__center">
          <li className="list__item-center">Уменьшение объёмов и целлюлита</li>
          <li className="list__item-center">Повышение упругости и эластичности кожи</li>
          <li className="list__item-center">Улучшение кровообращения и лимфодренажа</li>
          <li className="list__item-center">Выведение токсинов и шлаков</li>
          <li className="list__item-center">Снятие мышечного напряжения и боли</li>
          <li className="list__item-center">Общее оздоровление и релаксация</li>
        </ul>
      </div>
      <div className="variants__item-right">
        <img className="variants__item-icon-right" src={IconBody} alt="Иконка тела" />
        <h3 className="variants__item-title-right">Жемчужная ванна</h3>
        <ul className="variants__item-list list list__right">
          <li className="list__item-right">Релаксация и снятие стресса</li>
          <li className="list__item-right">Улучшение кровообращения</li>
          <li className="list__item-right">Смягчение и увлажнение кожи</li>
          <li className="list__item-right">Облегчение боли в мышцах и суставах</li>
          <li className="list__item-right">Общее оздоровление организма</li>
        </ul>
      </div>
    </div>
   );
}

export default variants;